import { render, staticRenderFns } from "./headerError.vue?vue&type=template&id=53277f22&lang=pug&"
import script from "./headerError.vue?vue&type=script&lang=ts&"
export * from "./headerError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports